import { Collapse, IconButton } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import React from 'react'
import CloseIcon from '@material-ui/icons/Close'
import { IError } from './Type'
import { useStyles } from './Style'

const FormError = ({ hasError, close }: IError): React.ReactElement => {
  const classes = useStyles()
  return (
    <Collapse in={!!hasError}>
      <Alert
        severity="error"
        className={classes.errorAlert}
        action={
          <IconButton aria-label="close" color="inherit" size="small" onClick={close}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {hasError}
      </Alert>
    </Collapse>
  )
}

export default FormError
